import {DefaultTheme} from "styled-components";

export const GlobalTheme: (principal: string) => DefaultTheme = (principal) => ({
    cores: {
        claro: "#fff",
        escuroTransparente: "rgba(0, 0, 0, .2)",
        principal: principal
    }
})